import { IIconProps } from '@cian/ui-kit/icons/internal';
import { FC } from 'react';
import styles from './RailwayItem.css';
import { UIText2 } from '@cian/ui-kit';

interface IRailwayItemProps {
  icon: FC<IIconProps>;
  name: string;
  travelTime: string;
  travelTypeIcon: FC<IIconProps>;
}

export const RailwayItem: FC<IRailwayItemProps> = ({
  icon: Icon,
  travelTypeIcon: TravelTypeIcon,
  travelTime,
  name,
}) => {
  return (
    <div className={styles['railway-item']}>
      <Icon />
      <UIText2>{name}</UIText2>
      <div className={styles['travel-info']}>
        <TravelTypeIcon />
        <UIText2 color="gray60_100">{travelTime}</UIText2>
      </div>
    </div>
  );
};
